import { createSelector } from 'reselect';
import { getWidgetUiState } from './getWidgetUiState';
export const getShouldHideScrollButton = createSelector([getWidgetUiState], widgetUiState => widgetUiState.hideScrollToButton);